import { StateCreator } from "zustand";

export interface ILewkGenLimitSlice {
  // Constant for maximum number of generations a use can have : 5
  readonly MAX_GENERATIONS: number;

  // Stores hyrdation status of this slice/store
  isHydrated: boolean;

  // Visitor ID
  visitorId: string | null;

  // Usage count of lewkboard generations
  usageCount: number;

  // Function to set the visitor ID
  setVisitorId: (visitorId: string) => void;

  // Function to increment usage count
  incrementUsageCount(): void;

  // Function to set the hydration status
  setIsHydrated: (isHydrated: boolean) => void;
}

const INIT_STATE: Pick<
  ILewkGenLimitSlice,
  "MAX_GENERATIONS" | "visitorId" | "usageCount" | "isHydrated"
> = {
  MAX_GENERATIONS: 3,
  isHydrated: false,
  visitorId: null,
  usageCount: 0,
};

export const LewkGenLimitSlice: StateCreator<ILewkGenLimitSlice> = (set) => ({
  ...INIT_STATE,
  setVisitorId: (visitorId: string) => set({ visitorId }),
  incrementUsageCount: () =>
    set((state) => {
      return { usageCount: state.usageCount + 1 };
    }),
  setIsHydrated: (isHydrated: boolean) => set({ isHydrated }),
});
